"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSelector = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = require("styled-components");
var clsx_1 = __importDefault(require("clsx"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var lodash_1 = require("lodash");
var react_click_away_listener_1 = __importDefault(require("react-click-away-listener"));
var utils_1 = require("../../utils");
var hooks_1 = require("../../hooks");
var flatNodes_1 = require("./flatNodes");
var transifex_1 = require("../../transifex");
var classNamePrefix = utils_1.createPrefixer("wh-Components-TreeSelector-");
var classes = {
    dropdown: classNamePrefix(templateObject_1 || (templateObject_1 = __makeTemplateObject(["dropdown"], ["dropdown"]))),
    dropdownHideSwitcherIcon: classNamePrefix(templateObject_2 || (templateObject_2 = __makeTemplateObject(["dropdownHideSwitcherIcon"], ["dropdownHideSwitcherIcon"]))),
};
var TreeSelectorGlobalStyles = styled_components_1.createGlobalStyle(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  .", " {\n      &.", " {\n        .ant-select-tree-switcher {\n          display: none;\n        }\n      }\n  }\n"], ["\n  .", " {\n      &.", " {\n        .ant-select-tree-switcher {\n          display: none;\n        }\n      }\n  }\n"])), classes.dropdown, classes.dropdownHideSwitcherIcon);
var TreeSelector = function (_a) {
    var onChange = _a.onChange, hideSwitcherIcon = _a.hideSwitcherIcon, value = _a.value, treeExpandedKeys = _a.treeExpandedKeys, treeData = _a.treeData, iopen = _a.open, _b = _a.selectionMode, selectionMode = _b === void 0 ? "draft" : _b, props = __rest(_a, ["onChange", "hideSwitcherIcon", "value", "treeExpandedKeys", "treeData", "open", "selectionMode"]);
    var _c = hooks_1.usePropAsInternalState(value), draftValue = _c[0], setDraftValue = _c[1];
    var _d = hooks_1.usePropAsInternalState(iopen), open = _d[0], setOpen = _d[1];
    var resetChange = react_1.useCallback(function () { return setDraftValue(value); }, [value, setDraftValue]);
    var isDirty = !react_fast_compare_1.default(draftValue, value);
    var updateValue = function (args) {
        setOpen(false); // close dropdown
        onChange === null || onChange === void 0 ? void 0 : onChange(args);
    };
    react_1.useEffect(function () {
        if (selectionMode === "immediate") {
            onChange === null || onChange === void 0 ? void 0 : onChange(draftValue);
        }
    }, [draftValue, onChange, selectionMode]);
    return (react_1.default.createElement(react_click_away_listener_1.default, { onClickAway: resetChange },
        react_1.default.createElement("div", null,
            react_1.default.createElement(antd_1.TreeSelect, __assign({}, props, { open: open, treeData: treeData, value: draftValue, onChange: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    setDraftValue(args[0]);
                }, onDeselect: function () {
                    var _a;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    setOpen(true);
                    (_a = props.onDeselect) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([props], args));
                }, dropdownClassName: clsx_1.default(classes.dropdown, props.dropdownClassName, hideSwitcherIcon && classes.dropdownHideSwitcherIcon), treeExpandedKeys: hideSwitcherIcon
                    ? lodash_1.flatMapDeep(treeData, flatNodes_1.flatNodes).map(function (n) { return n.key; })
                    : treeExpandedKeys, onDropdownVisibleChange: function (v) {
                    var _a;
                    setOpen(v);
                    (_a = props === null || props === void 0 ? void 0 : props.onDropdownVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
                }, dropdownRender: function (node) {
                    return selectionMode === "draft" ? (react_1.default.createElement(antd_1.Space, { direction: "vertical", style: { width: "100%" }, size: 8 },
                        react_1.default.createElement("div", { style: { padding: "0 " + (hideSwitcherIcon ? "8" : "0") + "px" } }, node),
                        react_1.default.createElement(antd_1.Divider, { style: { margin: 0 } }),
                        react_1.default.createElement(antd_1.Space, { style: {
                                justifyContent: "flex-end",
                                width: "100%",
                                padding: "0 8px",
                            } },
                            react_1.default.createElement(antd_1.Button, { onClick: function () { return updateValue([]); } }, transifex_1.TX_CLEAR),
                            react_1.default.createElement(antd_1.Button, { disabled: !isDirty, type: "primary", onClick: function () { return updateValue(draftValue); } }, transifex_1.TX_APPLY)))) : (node);
                } })),
            react_1.default.createElement(TreeSelectorGlobalStyles, null))));
};
exports.TreeSelector = TreeSelector;
TreeSelector.classes = classes;
var templateObject_1, templateObject_2, templateObject_3;
